import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import { Box, Button, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router';
import { authSecondarySx } from './styles';

/** Where the installers are served from (the same server as the web app, unless configured). */
export const WINDOWS_URL =
  (import.meta.env.VITE_DESKTOP_WINDOWS_URL as string | undefined) ??
  '/downloads/PackPilot-Setup.exe';
export const MAC_URL =
  (import.meta.env.VITE_DESKTOP_MAC_URL as string | undefined) ?? '/downloads/PackPilot.dmg';
export const UBUNTU_URL =
  (import.meta.env.VITE_DESKTOP_UBUNTU_URL as string | undefined) ??
  '/downloads/packpilot_amd64.deb';

export function WindowsLogo() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M3 5.1 10.4 4v7.1H3V5.1Zm0 13.8 7.4 1.1v-7H3v5.9Zm8.3 1.2L21 21.5V13h-9.7v7.1Zm0-16.2V11H21V2.5l-9.7 1.4Z"
      />
    </svg>
  );
}

export function UbuntuLogo() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <circle cx="12" cy="12" r="4.2" fill="none" stroke="#fff" strokeWidth="1.9" />
      <circle cx="5.2" cy="12" r="2" fill="#fff" stroke="currentColor" strokeWidth="1" />
      <circle cx="15.4" cy="6.1" r="2" fill="#fff" stroke="currentColor" strokeWidth="1" />
      <circle cx="15.4" cy="17.9" r="2" fill="#fff" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

export function AppleLogo() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M16.37 12.6c-.02-2.2 1.8-3.26 1.88-3.31-1.03-1.5-2.62-1.7-3.18-1.73-1.35-.14-2.64.8-3.33.8-.69 0-1.74-.78-2.87-.76-1.47.02-2.83.86-3.59 2.18-1.54 2.66-.39 6.6 1.1 8.77.73 1.06 1.6 2.24 2.73 2.2 1.1-.04 1.51-.71 2.84-.71 1.32 0 1.7.71 2.86.69 1.18-.02 1.93-1.07 2.65-2.13.84-1.22 1.18-2.41 1.2-2.47-.03-.01-2.3-.88-2.32-3.5ZM14.2 6.13c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.54 1.31-.56.64-1.05 1.67-.92 2.66.97.07 1.96-.49 2.56-1.21Z"
      />
    </svg>
  );
}

export function thisComputer(): 'windows' | 'mac' | 'ubuntu' | null {
  const ua = navigator.userAgent;
  if (/Macintosh|Mac OS X/i.test(ua) && !/iPhone|iPad/i.test(ua)) return 'mac';
  if (/Windows/i.test(ua)) return 'windows';
  if (/Linux/i.test(ua) && !/Android/i.test(ua)) return 'ubuntu';
  return null;
}

/** Sign-in page: one button to the install page, opened on this computer's system (no download here). */
export function DesktopDownloads() {
  const mine = thisComputer();
  return (
    <Box
      component="section"
      aria-labelledby="desktop-app-title"
      sx={(t) => ({
        mt: { xs: 2, sm: 3.5 },
        p: { xs: 1.5, sm: 2 },
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: alpha(t.palette.text.primary, 0.025),
      })}
    >
      <Typography id="desktop-app-title" sx={{ fontWeight: 650, fontSize: 14 }}>
        Get the desktop app
      </Typography>
      <Typography color="text.secondary" sx={{ fontSize: 12.5, mb: { xs: 1, sm: 1.5 } }}>
        Keeps selling offline and syncs when you’re back online. For Windows, macOS and Ubuntu.
      </Typography>
      <Button
        component={RouterLink}
        to={mine ? `/install?os=${mine}` : '/install'}
        fullWidth
        variant="outlined"
        endIcon={<ArrowForwardRounded />}
        sx={authSecondarySx}
      >
        Download desktop app
      </Button>
    </Box>
  );
}
